<template>
  <div class="container">
            <div class="title">
                <span>基本信息</span>
            </div>
            <div class="containerBody">
         <a-form-model :model="enviroment" ref="categoriesRef" >
        <a-row>
          <a-col :span="12">
            <a-form-model-item  :label-col="{ span: 6 }"  class="model_span_form" :wrapper-col="{ span: 18 }" label="企业名称" >
              <span>{{propRowData.companyName  }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }" label="企业地址">
              <span>{{propRowData.address }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item :label-col="{ span: 6 }" class="model_span_form" :wrapper-col="{ span: 18 }" label="选择子项目" prop="projectCategoryId"
                :rules="{
                  required: true,
                  message: '请选择子项目',
                  trigger: 'change',
                }"
              >
                <a-select  mode="multiple" allowClear placeholder="请选择子项目"  v-model="enviroment.projectCategoryId" @change="chooseProjectCategory">
                  <a-select-option :value="item.id" v-for="(item, index) in datalist" :key="index">
                    {{ item.abbreviationCategory }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
           
          
             <a-col :span="12">
              <a-form-model-item :label-col="{ span: 6 }"  class="model_span_form" :wrapper-col="{ span: 18 }" label="行业"  prop="industryId"
                :rules="{
                  required: true,
                  message: '请输入行业',
                  trigger: 'change',
                }"
              >
                <a-select allowClear placeholder="所属行业" v-model="enviroment.industryId" @change="chooseSub">
                  <a-select-option :value="item.id" v-for="(item, index) in industryList" :key="index">
                    {{ item.industryName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            </a-row>
         </a-form-model>

            </div>

  </div>
</template>

<script>
import {itemsChildren_list, industryInfo} from '@/api/Industry'
export default {
     props: [
        'propRowData',
        'rowData'
     ],
     data() {
        return {
            current: 0,
            informationList: {},
            enviroment: {
                subId: undefined
            },
            datalist: [],
            industryList: [],
            // subList: [],
            enviromentList: {}
        }
    },
    created() {
        //获得子项目列表
         itemsChildren_list({
        parentId: this.rowData.id
      }).then((res) => {
           if(res.code == 200) {
          this.datalist = res.data
          console.log(this.datalist, 'this.datalist')
           } else {
            this.$message.error(res.msg)
           }
      })
       //获取行业列表
    industryInfo({
      projectId: this.rowData.id
    }).then((res) => {
        if (res.code == 200) {
         this.industryList = res.data
      } else {
        this.$message.error('获取获取行业列表失败！')
      }
        
    })

    },
    methods: {
        // // 选择行业
        chooseSub(e) {
          console.log(e,'eeeeeeeeeeeeeeeeeeeeeeeeee11111111111111')
          this.enviromentList.forEach(item => {
             Object.assign(item, {
            masterCategoryId: e
          })
          })
       
          this.$emit('chooseCategory', this.enviromentList)
            this.enviroment.subId = ''

        },
        // //选择子项目
        chooseProjectCategory(e) {
            this.enviromentList = []
            console.log(e,'eeeeeeeeeeeeeeeeeeeeeeeeee')
                 this.datalist.forEach(item => {
            for(var i=0; i<e.length ; i++) {

                     if(item.id == e[i]){
                    this.enviromentList.push(item)

                 }
            }
                 })
        //            this.enviromentList.forEach(item => {
        //      Object.assign(item, {
        //     subId: e
        //   })
        //   })
             console.log( this.enviromentList, ' this.enviromentList=======================')
             this.$emit('chooseCategory', this.enviromentList)
                
            }
         


    }

}
</script>

<style>
.container {
    padding: 10px;
}
.title {
    font-size: 16px;

}
.containerBody {
    background-color: #fff;
    border-radius: 15px;
}

</style>